const GiftCardType = () =>
  import(
    /* webpackChunkName: "financial-discount-gift-card-type" */ '@/pages/financial/discount/gift-card-type/index.vue'
  )
const CreateGiftCardType = () =>
  import(
    /* webpackChunkName: "financial-discount-gift-card-type" */ '@/pages/financial/discount/gift-card-type/create.vue'
  )
const EditGiftCardType = () =>
  import(
    /* webpackChunkName: "financial-discount-gift-card-type" */ '@/pages/financial/discount/gift-card-type/edit.vue'
  )

export default {
  path: 'gift-card-type',
  meta: {
    label: 'giftCardTypes',
    auth: 'giftCardType'
  },
  component: {
    name: 'GiftCard',
    render(c) {
      return c('router-view')
    }
  },
  children: [
    {
      name: 'FinancialDiscountGiftCardType',
      path: '',
      meta: {
        label: 'report',
        auth: 'report'
      },
      component: GiftCardType
    },
    {
      name: 'FinancialCreateDiscountGiftCardType',
      path: 'create',
      meta: {
        label: 'create',
        auth: 'create'
      },
      component: CreateGiftCardType
    },
    {
      name: 'FinancialEditDiscountGiftCardType',
      path: 'edit/:id',
      meta: {
        label: 'edit',
        auth: 'update'
      },
      component: EditGiftCardType,
      props: true
    }
  ]
}
